export const API_URL =
  process.env.NODE_ENV === "production"
    ? "https://zeropa-api.herokuapp.com"
    : "http://localhost:3001";
export const UI_URL =
  process.env.NODE_ENV === "production"
    ? "https://zeropa.co.uk"
    : "http://localhost:3000";
export const CONSENT_COOKIE = "consent";
export const CONSENT_SESSION = "consent_session";
export const CONSENT_FUNCTIONAL = "consent_functional";
export const CONSENT_ADVERTISING = "consent_advertising";
export const GOOGLE_ID = "G-GEDZW5CQ0J";
export const GOOGLE_ID_SIMPLIFIED = "GEDZW5CQ0J";

export const JUPITER_TOKEN = "jupiter-token";

export const FRIENDLY_URL = "zeropa.co.uk";
export const COMPANY = "ZeroPA Holdings Ltd.";
export const COMPANY_FRIENDLY = "ZeroPA";
export const REGISTERED_COUNTRY = "England and Wales";
export const COMPANY_NUMBER = "06872579";
export const SUPPORTED_LOCATION = "United Kingdom";

export const COMPANY_ADDRESS =
  "Wenta Business Centre, Colne Way, Watford, England WD24 7ND.";
export const COMPANY_CIC_NAME = "ZeroPA CIC";
export const COMPANY_CIC_NUMBER = "13285651";
export const COMPANY_CIC_ADDRESS =
  "Upper Leys, High St, Pavenham, MK43 7PD, England";

export const ldJson = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "ZeroPA",
  url: "https://zeropa.co.uk",
  logo: "https://zeropa.s3.eu-west-1.amazonaws.com/zeropa-on-transparent.png",
  sameAs: [
    "https://facebook.com/zeropamadadcic",
    "https://linkedin.com/company/zeropa/",
  ],
};
